import { useEffect } from 'react';
import BrowserCookies from '~/utilities/BrowserCookies';
import {
  type NewCarsFlowLevel,
  NEW_CARS_FLOW_LEVEL_COOKIE,
  parseFlowLevel
} from '~/utilities/new-cars/newCarsFlowLevel';

export default function useRecordNewCarsFlowVisit(
  pageLevel: NewCarsFlowLevel
): void {
  useEffect(() => {
    const current = parseFlowLevel(
      BrowserCookies.get(NEW_CARS_FLOW_LEVEL_COOKIE) ?? undefined
    );

    if (current === null || pageLevel >= current) {
      BrowserCookies.set(NEW_CARS_FLOW_LEVEL_COOKIE, String(pageLevel), {
        path: '/new'
      });
    }
  }, [pageLevel]);
}
